import React, { useEffect, useState } from 'react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
// import slideOne from '../../img/slide-one.png';
import { fetchlimitedApprovedPosts } from '../../utils/PostComponents';
import { useNavigate } from 'react-router-dom';
import { truncateDescription } from '../../utils/truncateDescritopn';
const Base_Url = process.env.REACT_APP_BASE_URL;


const SwiperSection = () => {
    const [posts, setPosts] = useState([]);
    let navigate = useNavigate();
    useEffect(() => {
        fetchlimitedApprovedPosts(setPosts);
    }, []);

    const handleViewPost = (post) => {
        navigate(`/view/post/${post._id}`);
    };

    return (
        <>
            <section className="fliying-help-slider display-none">
                <div className="slider-container">
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        slidesPerView={4.5}
                        spaceBetween={0}
                        centeredSlides={false}
                        autoplay={{ delay: 1500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 4.5,
                                spaceBetween: 0,
                            },
                        }}
                    >
                        {posts.map((post) => (
                            <SwiperSlide key={post._id}>
                                <div className="slide-box">
                                    
                                    <div className='slider-image post_slideimg'>
                                    <img src={`${Base_Url}/assets/postThumbnails/${post.attachment}`} alt="" />
                                    </div>
                                    <h2 className="slider-title post-title">{post.title}</h2>
                                    <h4 className="slider-amount">${post.amount}</h4>
                                    <div
                                        className="slider-description"
                                        dangerouslySetInnerHTML={{ __html: truncateDescription(post.description, 30) }}
                                    />
                                    <div className="donate-main">
                                        <button className="swiper-btn learn-more" aria-label="Donate Now" onClick={() => { handleViewPost(post) }}>Learn More</button>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </>
    );
};

export default SwiperSection;
